import type { MessengerEmailViewSettings } from '@widgets/messenger/types'
import { useWidgetChannels } from '@widgets/messenger/compositions/useWidgetChannels'
import { useWidgetStore } from '@widgets/messenger/stores/useWidgetStore'
import { computed } from '@/composition/vue/compositionApi'
import { WebWidgetChannelType } from '@/data/models/domain/messages/settings/webWidget/types'

export const useWidgetEmailViewSettings = () => {
  const { widgetSettings } = useWidgetStore()
  const { channelMap } = useWidgetChannels()

  return computed<MessengerEmailViewSettings>(() => {
    const { title, description, buttonText, fieldSorting } =
      widgetSettings.value.channels[WebWidgetChannelType.EMAIL].uiSettings.mainScreen

    return {
      channel: channelMap.value[WebWidgetChannelType.EMAIL],
      title,
      description,
      buttonText,
      formFields: fieldSorting.map((fieldName, index) => {
        const isRequired =
          fieldName === 'name' ? widgetSettings.value.channels[WebWidgetChannelType.EMAIL].fieldSettings.name : true
        return {
          name: fieldName,
          order: index + 1,
          isRequired,
        }
      }),
    } satisfies MessengerEmailViewSettings
  })
}
